export default function ChartCard({ title, testid, children }) {
  return (
    <div
      data-testid={testid}
      className="bg-white border-2 border-slate-200 rounded-2xl p-6"
    >
      {title && (
        <h3 className="text-lg font-bold text-slate-900 mb-4">{title}</h3>
      )}
      {children}
    </div>
  );
}
